<template>
<a-modal
    :zIndex="1052"
    v-bind:open="showModal"
    width="420px"
    :closable="true"
    :footer="null"
    :mask-closable="true"
    :mask-style="{backdropFilter: 'blur(2px)'}"
    :keyboard="false"
    footer
    :destroyOnClose="true"
    @cancel="closeModal"
    centered
    title="발송 국가 선택"
>
    <div class="country-code-modal">
        <div class="country-code-modal-body">
            <a-select
                v-model:value="selectedCountryCode"
                :options="availableCountryCodes"
                class="country-code-modal-select"
                placeholder="국가 코드 또는 나라명을 입력하세요"
                show-search
                :filter-option="filterOption"
                :not-found-content="null"
                :dropdown-style="{ zIndex: 1052 }"
            ></a-select>
            <a-button
                type="primary"
                @click="emitCountryCode"
            >
                선택
            </a-button>
        </div>
        <div class="country-code-modal-footer">
            <a-button
                @click="closeModal"
            >닫기</a-button>
        </div>
    </div>
</a-modal>
</template>
<script>
import { oneBtnDialog } from '@/utils/utils';

const readonly = {
    closeModal: 'closeModal',
    emitCountryCode: 'emitCountryCode',
}

const fullCountryCodes = [
    { value: '+1', label: '+1 (미국/캐나다)' },
    { value: '+7', label: '+7 (러시아)' },
    { value: '+20', label: '+20 (이집트)' },
    { value: '+27', label: '+27 (남아프리카공화국)' },
    { value: '+30', label: '+30 (그리스)' },
    { value: '+31', label: '+31 (네덜란드)' },
    { value: '+32', label: '+32 (벨기에)' },
    { value: '+33', label: '+33 (프랑스)' },
    { value: '+34', label: '+34 (스페인)' },
    { value: '+36', label: '+36 (헝가리)' },
    { value: '+39', label: '+39 (이탈리아)' },
    { value: '+40', label: '+40 (루마니아)' },
    { value: '+41', label: '+41 (스위스)' },
    { value: '+43', label: '+43 (오스트리아)' },
    { value: '+44', label: '+44 (영국)' },
    { value: '+45', label: '+45 (덴마크)' },
    { value: '+46', label: '+46 (스웨덴)' },
    { value: '+47', label: '+47 (노르웨이)' },
    { value: '+48', label: '+48 (폴란드)' },
    { value: '+49', label: '+49 (독일)' },
    { value: '+51', label: '+51 (페루)' },
    { value: '+52', label: '+52 (멕시코)' },
    { value: '+53', label: '+53 (쿠바)' },
    { value: '+54', label: '+54 (아르헨티나)' },
    { value: '+55', label: '+55 (브라질)' },
    { value: '+56', label: '+56 (칠레)' },
    { value: '+57', label: '+57 (콜롬비아)' },
    { value: '+58', label: '+58 (베네수엘라)' },
    { value: '+60', label: '+60 (말레이시아)' },
    { value: '+61', label: '+61 (호주)' },
    { value: '+62', label: '+62 (인도네시아)' },
    { value: '+63', label: '+63 (필리핀)' },
    { value: '+64', label: '+64 (뉴질랜드)' },
    { value: '+65', label: '+65 (싱가포르)' },
    { value: '+66', label: '+66 (태국)' },
    { value: '+81', label: '+81 (일본)' },
    { value: '+82', label: '+82 (대한민국)' },
    { value: '+84', label: '+84 (베트남)' },
    { value: '+86', label: '+86 (중국)' },
    { value: '+90', label: '+90 (터키)' },
    { value: '+91', label: '+91 (인도)' },
    { value: '+92', label: '+92 (파키스탄)' },
    { value: '+93', label: '+93 (아프가니스탄)' },
    { value: '+94', label: '+94 (스리랑카)' },
    { value: '+95', label: '+95 (미얀마)' },
    { value: '+98', label: '+98 (이란)' },
];

export default {
    props: {
        certificateText: {
            type: String
        },
        showModal: {
            type: Boolean,
            required: true,
            default: false
        },
        currentCountryCode: {
            type: String,
            required: true,
            default: ''
        },
    },
    emits: [readonly.closeModal, readonly.emitCountryCode],
    data() {
        return {
            availableCountryCodes: fullCountryCodes,
            selectedCountryCode: undefined,
        }
    },
    watch: {
        showModal(newVal) {
            if (newVal) {
                this.selectedCountryCode = undefined;
            }
        }
    },
    methods: {
        closeModal() {
            if(this.selectedCountryCode === 'ETC') {
                this.selectedCountryCode = this.currentCountryCode;
            }

            this.$emit(readonly.emitCountryCode, this.currentCountryCode);
            this.$emit(readonly.closeModal, 'countryCodeModal', false);
        },
        filterOption(input, option) {
            return (
                option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
            );
        },
        async emitCountryCode() {
            if(!this.selectedCountryCode) {
                return await oneBtnDialog('국가 코드 미선택', '국가 코드를 선택해 주세요.', false);
            }

            this.$emit(readonly.emitCountryCode, this.selectedCountryCode);
        },
    }
}
</script>
<style lang="scss" scoped>
.country-code-modal {
    width: 100%;
    .country-code-modal-body {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 8px;
        padding: 20px;
        .country-code-modal-select {
            width: 100%;
        }
    }
    .country-code-modal-footer {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 20px 20px 20px;
    }
}
</style>
